
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Robert André L., 99, verstorben am 7. April 2020</b>
    <br />
    <br />
    <i>Seine Schwiegertochter sagt:</i>
    <br />
    <p>
  «Er war eine starke Persönlichkeit, bis ins hohe Alter von 90 Jahren
  liebenswert und charmant. Dann wurde mein Schwiegervater zunehmend schwächer.
  Das machte ihm Sorgen. Manchmal fiel es ihm schwer, dies zu akzeptieren.
    </p>
    <p>
  Er wusste immer, was er wollte, und er gab sich immer die Mittel, es zu
  bekommen. So kämpfte er beispielsweise dafür, seinen Führerschein so lange wie
  möglich zu behalten. Er empfand es trotz seines Alters als Ungerechtigkeit,
  dass er ihn abgeben musste.
    </p>
    <p>
  Er hatte auf dem Dach seines Hauses eine Antenne installiert. Er war
  Funkamateur. So war er in der Lage, mit Menschen auf der ganzen Welt zu
  kommunizieren – auf Französisch, Englisch und Niederländisch.
    </p>
    <p>
  Das Coronavirus beunruhigte ihn zunächst nicht sehr. Er fand erst heraus, dass
  er positiv ist, als das Altersheim entschied, alle Bewohner zu testen. Er war
  gerade 99 Jahre alt geworden. Er litt an Herzinsuffizienz und war bereits sehr
  geschwächt. Deshalb hatte er nicht die Kraft, das Coronavirus abzuwehren. Als
  das Virus zuschlug, ging alles sehr schnell.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;